module.exports = __webpack_public_path__ + "img/product_67.4eb3800.webp";